import React, { useState, useCallback } from 'react';
import axios from 'axios';

const VBUploader = ({ param1, param2 }) => {
  const [selectedFile, setSelectedFile] = useState(null);

  let subfolder = "";
  let fileType = "";
  let fileSize = "";

  switch (param1) {
    case "Cover Image":
      subfolder = "/visualbrief/coverimage";
      fileType = "png";
      fileSize = "2MB";
      break;
    case "Slide Image":
      subfolder = "/visualbrief";
      fileType = "png";
      fileSize = "2MB";
      break;
    default:
      subfolder = "/visualbrief/slidevideo";
      fileType = "mp4";
      fileSize = "10MB";
      break;
  }

  const onFileChange = useCallback((event) => {
    setSelectedFile(event.target.files[0]);
  }, []);

  const onFileUpload = useCallback(async () => {
    if (!selectedFile) {
      alert("Please select a file first");
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      const response = await axios.post(`/api/uploads${subfolder}`, param2, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      alert("File uploaded successfully!");
      // console.log("Upload response:", response.data);
    } catch (error) {
      console.error("Error uploading file:", error);
      alert("Failed to upload file");
    }
  }, [selectedFile, subfolder]);

  return (
    <div className="border-2 flex flex-col text-white p-4">
      {/* {param2} */}
      <input type="file" onChange={onFileChange} accept={fileType} />
      <button 
        onClick={onFileUpload} 
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4"
      >
        Upload {param1}
      </button>
    </div>
  );
};

export default VBUploader;
